export type Locale = 'en' | 'nl';

export const DEFAULT_LOCALE: Locale = 'en';

/**
 * English routes use no prefix; Dutch uses `/nl` (e.g. `/nl/onboard`).
 */
export function parseLocale(pathname: string): { locale: Locale; strippedPath: string } {
  const raw = pathname.split('?')[0] || '/';
  let p = raw;
  if (p.length > 1 && p.endsWith('/')) {
    p = p.slice(0, -1);
  }
  if (p === '/nl') {
    return { locale: 'nl', strippedPath: '/' };
  }
  if (p.startsWith('/nl/')) {
    const rest = p.slice('/nl'.length);
    return { locale: 'nl', strippedPath: rest || '/' };
  }
  return { locale: 'en', strippedPath: p || '/' };
}

export function withLocalePrefix(locale: Locale, path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (locale === 'en') {
    return normalized === '/' ? '/' : normalized;
  }
  if (normalized === '/') {
    return '/nl';
  }
  return `/nl${normalized}`;
}



// WEBPACK FOOTER //
// ./src/i18n/localePath.ts